import { Component, Inject, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { IAngularMyDpOptions } from '@nodro7/angular-mydatepicker';
import { Subscription } from 'rxjs';
import { APP_CONFIG } from '../../../../app.config';
import { AssistantPopoverService } from '../../../../common/assistant-popover.service';
import { DateUtilsService } from '../../../../common/date-utils.service';
import { DATEPICKER_CONFIG } from '../../../../common/datepicker-config';
import { FixDateService } from '../../../../common/fixDate.service';
import { ValidationService } from '../../../../common/validation.service';
import { ValueListsService } from '../../../../common/value-lists.service';
import { AppConfig } from '../../../../models/config/app-config';
import { ValueListItem } from '../../../../models/rest/valuelist/valuelist';
import { VisumErfassungSubFormComponent } from '../../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-lebensunterhalt',
  templateUrl: './lebensunterhalt.component.html',
  styleUrls: ['./lebensunterhalt.component.scss']
})
export class LebensunterhaltComponent extends VisumErfassungSubFormComponent implements OnInit, OnDestroy {
  private abweichenderVerpflichtungsgeberSub: Subscription;
  private behoerdeOptionsSub: Subscription;
  behoerdeOptions: ValueListItem[];

  isVerpflichtungserklaerungDataVisible: boolean;


  constructor(
    fb: FormBuilder,
    private valueListsService: ValueListsService,
    private validationService: ValidationService,
    @Inject(DATEPICKER_CONFIG) public datepickerOptions: IAngularMyDpOptions,
    @Inject(APP_CONFIG) public appConfig: AppConfig,
    fixDateService: FixDateService,
    dateUtils: DateUtilsService,
    assistantPopoverService: AssistantPopoverService,
    @Optional() @Self() controlDir: NgControl
  ) {
    super(controlDir, assistantPopoverService);

    this.form = this.wrapFormGroup(fb.group({
      mittel: [null, validationService.getValidators('reisedaten.lebensunterhalt.sonstigesText')],
      abweichenderVerpflichtungsgeber: ['nein', []],
      verpflichtungsgebendeBehoerde: [null, validationService.getValidators('verpflichtungserklaerungsgeber.foermlicheVerpflichtungserklaerung.behoerde')],
      erklaerungDatum: [null, validationService.getValidators('antragsteller.verpflichtungsgeber.foermlicheVerpflichtungserklaerung.datum', true)],
      aufenthaltStrasse: [null, validationService.getValidators('zusatzangaben.aufenthaltStrasse')],
      aufenthaltHausnummer: [null, validationService.getValidators('zusatzangaben.aufenthaltHausnummer')],
      aufenthaltPlz: [null, validationService.getValidators('zusatzangaben.aufenthaltPlz')],
      aufenthaltort: [null, validationService.getValidators('zusatzangaben.aufenthaltOrt')],
      einzelzimmer: [null, validationService.getValidators('zusatzangaben.aufenthaltArt.einzelzimmer')],
      wohnung: [null, validationService.getValidators('zusatzangaben.aufenthaltArt.wohnung')],
      zimmer: [null, validationService.getValidators('zusatzangaben.aufenthaltArt.zimmer')],
      sammelunterkunft: [null, validationService.getValidators('zusatzangaben.aufenthaltArt.sammelunterkunft')],
      sonstiges: [null, validationService.getValidators('zusatzangaben.aufenthaltArt.sonstiges')],
      sonstigesTxt: [null, validationService.getValidators('zusatzangaben.aufenthaltArt.sonstigesText')],
      wohnortImAusland: [null, validationService.getValidators('antragsteller.personendaten.wohnortImAusland')],
      wohnortImAuslandOrt: [null, validationService.getValidators('antragsteller.personendaten.wohnortImAuslandOrt')],
      mitreisendeFamilienangehoerige: [null, validationService.getValidators('antragsteller.personendaten.mitreisendeFamilienangehoerige')],
      mitreisendeFamilienangehoerigeText: [null, validationService.getValidators('antragsteller.personendaten.mitreisendeFamilienangehoerigeText')],
      krankenversicherung: [null, validationService.getValidators('antragsteller.personendaten.krankenversicherung')]
    }));

    this.dateFixer = fixDateService.getConverter({ unknownReplacement: '00' });
    this.dateFormatter = dateUtils.getFormatter('yMd');
  }

  ngOnInit() {
    super.ngOnInit();

    this.behoerdeOptionsSub = this.valueListsService.getValueListItems('behoerde')
    .subscribe((listItems: ValueListItem[]) => this.behoerdeOptions = listItems);

    this.abweichenderVerpflichtungsgeberSub = this.form.controls.abweichenderVerpflichtungsgeber.valueChanges.subscribe(value => {
      if (this.form.value.abweichenderVerpflichtungsgeber !== value) {
        this.setVerpflichtungserklaerungDataVisible(value);
      }
    });
  }

  ngOnDestroy(): void {
    this.abweichenderVerpflichtungsgeberSub.unsubscribe();
    this.behoerdeOptionsSub.unsubscribe();
  }

  onValidatorUpdate() {
    this.setVerpflichtungserklaerungDataVisible(this.form.value.abweichenderVerpflichtungsgeber);
  }

  setVerpflichtungserklaerungDataVisible(abweichenderVerpflichtungsgeber: string): void {
    this.isVerpflichtungserklaerungDataVisible = abweichenderVerpflichtungsgeber === 'jaAbweichend' || abweichenderVerpflichtungsgeber === 'ja';
    this.enableDisableControls();
  }

  private enableDisableControls() {
    if (this.isVerpflichtungserklaerungDataVisible) {
      this.form.controls.verpflichtungsgebendeBehoerde.enable();
      this.form.controls.erklaerungDatum.enable();
    } else {
      this.form.controls.verpflichtungsgebendeBehoerde.disable();
      this.form.controls.erklaerungDatum.disable();
    }
  }

}
